/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurSuiviGridDto } from './FcbFormateurSuiviGridDto';
import {
    FcbFormateurSuiviGridDtoFromJSON,
    FcbFormateurSuiviGridDtoFromJSONTyped,
    FcbFormateurSuiviGridDtoToJSON,
} from './FcbFormateurSuiviGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurSuiviGridDtoPaginatedResults
 */
export interface FcbFormateurSuiviGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurSuiviGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurSuiviGridDto>}
     * @memberof FcbFormateurSuiviGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurSuiviGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurSuiviGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurSuiviGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurSuiviGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurSuiviGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurSuiviGridDtoPaginatedResults {
    return FcbFormateurSuiviGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurSuiviGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurSuiviGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurSuiviGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurSuiviGridDtoPaginatedResultsToJSON(value?: FcbFormateurSuiviGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurSuiviGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

